
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/henge",
      function () {
        return require("private-next-pages/projects/henge.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/henge"])
      });
    }
  